import { useEffect, useState } from 'react'

import { ClearSocketMessageHandler, GetActiveStadiumZones, GetUserZone, ResetAllResults, SetSocketMessageHandler } from './../../utilities/BL/Zones'
import { GetLotteryData, GetNewLotteryData, RemoveExtraClassesOfColorsDynamic, SaveLotteryData } from './../../utilities/BL/Games'

import { Welcome } from './Sections/Welcome'
import { Wait } from './Sections/Wait'
import { Quiz } from './Sections/Quiz'
import { Colors } from './Sections/Colors'
import { Thanks } from './Sections/Thanks'
import { InstructionsColors } from './Sections/InstructionsColor'
import { Lottery } from './Sections/Lottery'
import { Balloons } from './Sections/Balloons'
import { Riddle } from './Sections/Riddle'
import { QuizzWithImageAndOptions } from './Sections/QuizzWithImageAndOptions'
import { Noisemeter } from './Sections/Noisemeter'
import { NoisemeterV2 } from './Sections/NoisemeterV2'
import { FrontPageNoisemeter } from './Sections/Noisemeter/FrontPageNoisemeter'
import { FrontPageNoisemeterV2 } from './Sections/Noisemeter/FrontPageNoisemeterV2'
import { FrontPageLuchoFest } from './Sections/LuchoFest/FrontPageLuchoFest'
import { LuchoFest } from './Sections/LuchoFest'
import { LightShow } from './Sections/LightShow'
import { Picnic } from './Sections/Picnic'
import { Tacos } from './Sections/Tacos'

// IMPORTAMOS EL NUEVO COMPONENTE V2 DEL AFICIONADO
import { GoalV2 } from './Sections/GoalV2'
import { CarreraContinuaFan } from './Sections/CarreraContinuaFan'
import { FightersFan } from './Sections/FightersFan'
import { QuickReactionFan } from './Sections/QuickReactionFan'
// Memorama se ejecuta de forma exclusiva en la ruta dedicada /memory
import { TugOfWarFan } from './Sections/TugOfWarFan'

import { Voting } from './Sections/Voting'
import { Caps } from './Sections/Caps'

import { DeleteSessionData } from './../../utilities/BL/Sessions'


const Sections = ({ onLogout, defaultView }) => {
    // =========================================================================
    // 1. AJUSTE ORTOGRÁFICO: Debe coincidir EXACTAMENTE con VaronilZones del C#
    // =========================================================================
    const zonesTemplate = [
        { name: "Zona 1", text: "zona1" },
        { name: "Platea Zona 1", text: "zona2" },
        { name: "Palcos Zona 1", text: "zona3" },
        { name: "Cabecera Norte", text: "zona4" },
        { name: "Cabecera Sur", text: "zona5" },
        { name: "Zona 2", text: "zona6" },
        { name: "Platea Zona 2", text: "zona7" },
        { name: "Palcos Zona 2", text: "zona8" }
    ]

    const [isLoading, setIsLoading] = useState(true)
    const [zone, setZone] = useState(null)
    const [activeComponentId, setActiveComponentId] = useState(null)

    const [quizOptions, setQuizOptions] = useState([])
    const [quizQuestionId, setQuizQuestionId] = useState(null)
    const [color, setColor] = useState(null)
    const [lottery, setLottery] = useState(null)
    const [riddle, setRiddle] = useState(null)

    const [selectedZone, setSelectedZone] = useState(null)
    const [selectedZoneToComponent, setSelectedZoneToComponent] = useState(null)

    const [balloonConfig, setBalloonConfig] = useState(null)
    const [balloonWinners, setBalloonWinners] = useState(null)

    const [noisemeterConfig, setNoisemeterConfig] = useState(null);
    const [noisemeterWinners, setNoisemeterWinners] = useState(null);

    const [luchoFestConfig, setLuchoFestConfig] = useState(null);
    const [luchoFestEmergencyTrigger, setLuchoFestEmergencyTrigger] = useState(0);

    const [lightShowConfig, setLightShowConfig] = useState(null);

    const [displayZoneName, setDisplayZoneName] = useState('')

    // ==========================================
    // ESTADOS NUEVOS PARA TIRO A GOL V2
    // ==========================================
    const [goalV2Config, setGoalV2Config] = useState(null);
    const [goalV2MatchState, setGoalV2MatchState] = useState(null);
    const [goalV2WinnerZone, setGoalV2WinnerZone] = useState(null);

    // ==========================================
    // ESTADOS PARA CARRERA CONTINUA (HU-05)
    // ==========================================
    const [carreraContinuaConfig, setCarreraContinuaConfig] = useState(null);
    const [carreraContinuaMatchState, setCarreraContinuaMatchState] = useState(null);
    const [carreraContinuaWinnerZone, setCarreraContinuaWinnerZone] = useState(null);

    // ==========================================
    // ESTADOS PARA FIGHTERS (HU-05)
    // ==========================================
    const [fightersConfig, setFightersConfig] = useState(null);
    const [fightersMatchState, setFightersMatchState] = useState(null);
    const [fightersWinner, setFightersWinner] = useState(null);

    // ==========================================
    // ESTADOS PARA REACCIÓN RÁPIDA 1 VS 1 (HU-05)
    // ==========================================
    const [quickReactionConfig, setQuickReactionConfig] = useState(null);
    const [quickReactionMatchState, setQuickReactionMatchState] = useState(null);
    const [quickReactionWinner, setQuickReactionWinner] = useState(null);

    // Memorama opera desacoplado en /memory

    // ==========================================
    // ESTADOS PARA ESTIRA Y AFLOJA / TUG OF WAR (HU-05)
    // ==========================================
    const [tugOfWarConfig, setTugOfWarConfig] = useState(null);
    const [tugOfWarMatchState, setTugOfWarMatchState] = useState(null);
    const [tugOfWarWinner, setTugOfWarWinner] = useState(null);

    const [votingConfig, setVotingConfig] = useState(null);

    // const ToCanonicalZone = (raw, zonesTemplate = []) => {
    //     if (!raw) return null
    //     let s = String(raw).toLowerCase().trim()
    //     if (s.startsWith("zona ")) s = s.slice(5)
    //     s = s.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    //     s = s.replace(/\s+/g, " ").trim()
    //     if (Array.isArray(zonesTemplate) && zonesTemplate.length) {
    //         const canonList = zonesTemplate.map(z => ({
    //             canon: String(z.text).toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, " ").trim(),
    //             original: z.text
    //         }))
    //         const hit = canonList.find(z => z.canon === s)
    //         if (hit) return hit.original
    //     }
    //     return s
    // }

    // =========================================================================
    // 2. FUNCIÓN DE NORMALIZACIÓN MÁS INTELIGENTE
    // =========================================================================
    const ToCanonicalZone = (raw, zonesTemplate = []) => {
        if (!raw) return null

        let s = String(raw).toLowerCase().trim()
        if (s.startsWith("zona ")) s = s.slice(5).trim()

        // Creamos una versión sin acentos para la comparación "sucia"
        const noAccents = (str) => str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, " ").trim();
        const rawNoAccents = noAccents(s);

        if (Array.isArray(zonesTemplate) && zonesTemplate.length) {
            // Buscamos coincidencia relajada (sin acentos) pero retornamos la versión ESTRICTA (con acentos)
            const hit = zonesTemplate.find(z => noAccents(z.name.toLowerCase()) === rawNoAccents || noAccents(z.text) === rawNoAccents);
            if (hit) return hit.text; // Retorna "lounge ron potosí" (con acento)
        }

        return s;
    }

    const LoadPage = async () => {
        try {
            document.getElementById("root").classList.add("BodyComplete")
            document.body.classList.remove('Quiz__Background__Femenil--Blue')
            document.body.classList.remove('Quiz__Background__Femenil--Golden')

            const response = await GetUserZone()
            if (response.success) {
                const rawText = response.data?.text || "";
                let rawName = response.data?.name || "";

                // Fallback 1: Si no tiene name pero tiene text, buscar en zonesTemplate
                if (!rawName && rawText) {
                    const templateMatch = zonesTemplate.find(z => z.text.toLowerCase() === rawText.toLowerCase());
                    if (templateMatch) {
                        rawName = templateMatch.name;
                    }
                }

                const canon = ToCanonicalZone(rawText || rawName, zonesTemplate)
                setZone({ ...response.data, name: rawName || rawText, canonical: canon })
                setSelectedZoneToComponent(canon)
                setSelectedZone(rawName || rawText)

                // NUEVO: Consultamos el nombre visual de la fase activa
                const zonesRes = await GetActiveStadiumZones();
                let visualName = rawName || rawText; 
                if (zonesRes.success && rawText) {
                    const rawClean = rawText.toLowerCase().replace("zona ", "").trim();
                    const matchedZone = zonesRes.data.find(z => z.internalName === rawClean || z.internalName === rawText.toLowerCase());
                    if (matchedZone) {
                        visualName = matchedZone.displayName;
                    }
                }
                setDisplayZoneName(visualName);
                if (visualName) {
                    setSelectedZone(visualName);
                }
            }
        } catch (error) {
        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        LoadPage()

        const handler = async (payload) => {
            const type = payload?.type
            if (!type) return

            switch (type.toLowerCase()) {
                case "set.dynamic": {
                    const dyn = payload.data?.dynamic?.toLowerCase();
                    let nextComponentId = 1;

                    switch (dyn) {
                        case 'welcome': nextComponentId = 1; break;
                        case 'wait': nextComponentId = 2; break;
                        case 'thanks': nextComponentId = 8; break;
                        case 'trivia': nextComponentId = 3; break;
                        case 'colors': nextComponentId = 4; break;
                        case 'lottery': nextComponentId = 5; break;
                        case 'balloons': nextComponentId = 9; break;
                        case 'riddle': nextComponentId = 10; break;
                        case 'lightshow': nextComponentId = 14; break;
                        case 'goal': case 'runtogoal': nextComponentId = 15; break;
                        case 'noisemeter': nextComponentId = 12; break;
                        case 'voting': nextComponentId = 16; break;
                        case 'caps': nextComponentId = 17; break;
                        case 'carreracontinua': nextComponentId = 18; break;
                        case 'fighters': case 'luchadores': nextComponentId = 19; break;
                        case 'quickreaction': case 'quick_reaction': case 'reaccionrapida': case 'reaccion_rapida': nextComponentId = 43; break;
                        case 'memory': case 'memorama': nextComponentId = 2; break; // En / se mantiene en Wait
                        default: nextComponentId = 2; break;
                    }

                    if (dyn === 'lightshow') {
                        setLightShowConfig(prev => {
                            const isRunning = payload.data?.isRunning ?? prev?.isRunning ?? false;
                            return { ...prev, ...payload.data, isRunning };
                        });
                    }

                    setActiveComponentId(prevId => {
                        if (prevId === nextComponentId) {
                            return prevId;
                        }
                        RemoveExtraClassesOfColorsDynamic().catch(err => console.warn(err));
                        return nextComponentId;
                    });
                    break;
                }
                case "welcome":
                    await RemoveExtraClassesOfColorsDynamic()
                    setActiveComponentId(1)
                    break
                case "wait":
                    await RemoveExtraClassesOfColorsDynamic()
                    setActiveComponentId(2)
                    break
                case "trivia":
                    await RemoveExtraClassesOfColorsDynamic()
                    setActiveComponentId(3)
                    break
                case "options":
                    await RemoveExtraClassesOfColorsDynamic()
                    if (payload.data?.options?.length > 0) {
                        setQuizQuestionId(payload.data.questionId)
                        setQuizOptions(payload.data.options)
                        setColor(null)
                        setLottery(null)
                        setActiveComponentId(3.1)
                    }
                    break
                case "colores":
                    await RemoveExtraClassesOfColorsDynamic()
                    setActiveComponentId(4)
                    break
                case "setzonecolor":
                    if (payload?.color) {
                        setColor(payload.color)
                        setQuizQuestionId(null)
                        setQuizOptions(null)
                        setLottery(null)
                        setActiveComponentId(4.1)
                    }
                    break
                case "loteria":
                    await RemoveExtraClassesOfColorsDynamic()
                    setActiveComponentId(5)
                    break
                case "lotteryboard":
                    await RemoveExtraClassesOfColorsDynamic()
                    const response = await GetLotteryData(payload)
                    if (response.success) {
                        setColor(null); setQuizQuestionId(null); setQuizOptions(null);
                        setLottery(response.data)
                        setActiveComponentId(5.1)
                    } else {
                        const errorMessage = response?.message
                        if (errorMessage) {
                            console.log(errorMessage)
                        } else {
                            const responseNewData = await GetNewLotteryData(payload)
                            if (responseNewData.success) {
                                setColor(null); setQuizQuestionId(null); setQuizOptions(null);
                                setLottery(responseNewData.data)
                                await SaveLotteryData(responseNewData.data)
                                setActiveComponentId(5.1)
                            }
                        }
                    }
                    break
                case "start":
                    await RemoveExtraClassesOfColorsDynamic()
                    setActiveComponentId(7)
                    break
                case "thanks":
                    await RemoveExtraClassesOfColorsDynamic()
                    setActiveComponentId(8)
                    break

                // ==========================================
                // TIRO A GOL V2 (AFICIONADO)
                // ==========================================
                case "goal.created": {
                    await RemoveExtraClassesOfColorsDynamic();
                    const createdTheme = payload.payload?.theme || payload.payload?.themeSnapshot || payload.theme || payload.themeSnapshot || payload.payload?.cfg || payload.data?.theme || {};
                    setGoalV2Config(createdTheme);
                    setGoalV2MatchState({ matchId: payload.payload?.matchId || payload.data?.matchId, phase: 'WAITING', theme: createdTheme });
                    setGoalV2WinnerZone(null);
                    setActiveComponentId(15); // Pantalla de "Prepárate"
                    break;
                }

                case "goal.started": {
                    await RemoveExtraClassesOfColorsDynamic();
                    const startedTheme = payload.payload?.theme || payload.payload?.themeSnapshot || payload.theme || payload.themeSnapshot || payload.data?.theme;
                    if (startedTheme) {
                        setGoalV2Config(startedTheme);
                    }
                    setGoalV2MatchState(prev => ({ ...prev, matchId: payload.payload?.matchId || payload.data?.matchId || prev?.matchId, phase: 'RUNNING', theme: startedTheme || prev?.theme }));
                    setGoalV2WinnerZone(null);
                    setActiveComponentId(15.1); // Pantalla del Botón
                    break;
                }

                case "goal.progress": {
                    const progressPayload = payload.payload || payload.data;
                    if (progressPayload?.elapsedMilliseconds !== undefined) {
                        const progressTheme = progressPayload.theme || progressPayload.themeSnapshot || payload.theme || payload.themeSnapshot;
                        if (progressTheme) {
                            setGoalV2Config(progressTheme);
                        }
                        setGoalV2MatchState(prev => ({ ...prev, ...progressPayload, phase: 'RUNNING', theme: progressTheme || prev?.theme }));
                        setActiveComponentId(15.1);
                    }
                    break;
                }

                case "goal.finished": {
                    const finishedPayload = payload.payload || payload.data;
                    if (finishedPayload?.finalZonesProgress !== undefined || finishedPayload?.winner !== undefined) {
                        await RemoveExtraClassesOfColorsDynamic();
                        const finishedTheme = finishedPayload?.theme || finishedPayload?.themeSnapshot || payload.theme || payload.themeSnapshot;
                        if (finishedTheme) {
                            setGoalV2Config(finishedTheme);
                        }
                        setGoalV2MatchState(prev => ({ ...prev, phase: 'FINISHED', theme: finishedTheme || prev?.theme }));
                        setGoalV2WinnerZone(finishedPayload?.winner || payload.winner);
                        setActiveComponentId(15.1);
                    }
                    break;
                }

                case "goal.snapshot": {
                    await RemoveExtraClassesOfColorsDynamic();
                    const snapshotPayload = payload.payload || payload.data || payload;
                    const snapshotTheme = snapshotPayload.theme || snapshotPayload.themeSnapshot || payload.theme || payload.themeSnapshot || {};
                    if (snapshotTheme) {
                        setGoalV2Config(snapshotTheme);
                    }
                    setGoalV2MatchState({
                        matchId: snapshotPayload.matchId,
                        phase: snapshotPayload.phase || snapshotPayload.currentPhase || 'WAITING',
                        theme: snapshotTheme,
                        ...snapshotPayload
                    });
                    if (snapshotPayload.winner) {
                        setGoalV2WinnerZone(snapshotPayload.winner);
                    }
                    setActiveComponentId(snapshotPayload.phase?.toUpperCase() === 'RUNNING' || snapshotPayload.phase?.toUpperCase() === 'FINISHED' ? 15.1 : 15);
                    break;
                }

                case "goal.prepare":
                case "goal.reset": {
                    await RemoveExtraClassesOfColorsDynamic();
                    const resetTheme = payload.payload?.theme || payload.payload?.themeSnapshot || payload.theme || payload.themeSnapshot || payload.data?.theme;
                    if (resetTheme) {
                        setGoalV2Config(resetTheme);
                    }
                    setGoalV2MatchState({ matchId: payload.payload?.matchId || payload.data?.matchId, phase: 'WAITING', theme: resetTheme });
                    setGoalV2WinnerZone(null);
                    setActiveComponentId(15);
                    break;
                }

                // ==========================================
                // CARRERA CONTINUA (HU-05)
                // ==========================================
                case "carreracontinua.created":
                case "carreracontinua.create":
                case "carreracontinua.cover":
                case "carreracontinua.show_cover":
                case "carreracontinua.showcover":
                case "carreracontinua.project_game":
                case "carreracontinua.game":
                    await RemoveExtraClassesOfColorsDynamic();
                    const ccTheme = payload.payload?.theme || payload.payload?.data || payload.payload || payload.data || {};
                    setCarreraContinuaConfig(ccTheme);
                    setCarreraContinuaMatchState({ roomId: payload.payload?.roomId || payload.data?.roomId, phase: 'WAITING' });
                    setCarreraContinuaWinnerZone(null);
                    setActiveComponentId(18);
                    break;
                case "carreracontinua.countdown":
                    await RemoveExtraClassesOfColorsDynamic();
                    setCarreraContinuaMatchState(prev => ({ ...prev, phase: 'COUNTDOWN', secondsRemaining: payload.payload?.secondsRemaining ?? payload.data?.secondsRemaining }));
                    setActiveComponentId(18);
                    break;
                case "carreracontinua.started":
                    await RemoveExtraClassesOfColorsDynamic();
                    setCarreraContinuaMatchState(prev => ({ ...prev, phase: 'RUNNING' }));
                    setCarreraContinuaWinnerZone(null);
                    setActiveComponentId(18);
                    break;
                case "carreracontinua.progress":
                    if (payload.payload || payload.data) {
                        setCarreraContinuaMatchState(prev => ({ ...prev, ...(payload.payload || payload.data), phase: 'RUNNING' }));
                        setActiveComponentId(18);
                    }
                    break;
                case "carreracontinua.paused":
                    setCarreraContinuaMatchState(prev => ({ ...prev, phase: 'PAUSED' }));
                    break;
                case "carreracontinua.resumed":
                    setCarreraContinuaMatchState(prev => ({ ...prev, phase: 'RUNNING' }));
                    break;
                case "carreracontinua.finished":
                    await RemoveExtraClassesOfColorsDynamic();
                    setCarreraContinuaMatchState(prev => ({ ...prev, phase: 'FINISHED' }));
                    setCarreraContinuaWinnerZone((payload.payload?.winnerZone || payload.data?.winnerZone) ?? (payload.payload?.winner || payload.data?.winner));
                    setActiveComponentId(18);
                    break;
                case "carreracontinua.reset":
                    await RemoveExtraClassesOfColorsDynamic();
                    setCarreraContinuaMatchState({ phase: 'WAITING' });
                    setCarreraContinuaWinnerZone(null);
                    setActiveComponentId(18);
                    break;

                // ==========================================
                // FIGHTERS / BATALLA DE LUCHADORES (HU-05)
                // ==========================================
                case "fighters.cover":
                case "fighters_cover":
                case "fighters_cover_shown":
                case "fighters.game_scene":
                case "fighters_game_scene":
                case "fighters_game_scene_shown":
                case "fighters.created":
                case "fighters_created":
                    await RemoveExtraClassesOfColorsDynamic();
                    const fightersThemeData = payload.payload?.theme || payload.data?.theme || payload.payload || payload.data || {};
                    setFightersConfig(fightersThemeData);
                    setFightersMatchState({ roomId: payload.payload?.roomId || payload.data?.roomId, phase: payload.payload?.phase || payload.data?.phase || 'cover' });
                    setFightersWinner(null);
                    setActiveComponentId(19);
                    break;
                case "fighters.countdown":
                case "fighters_countdown":
                case "fighters_countdown_started":
                    await RemoveExtraClassesOfColorsDynamic();
                    setFightersMatchState(prev => ({ ...prev, phase: 'countdown', secondsRemaining: payload.payload?.countdown ?? payload.payload?.secondsRemaining ?? payload.data?.countdown }));
                    setActiveComponentId(19);
                    break;
                case "fighters.started":
                case "fighters_started":
                case "fighters_round_started":
                    await RemoveExtraClassesOfColorsDynamic();
                    setFightersMatchState(prev => ({ ...prev, ...(payload.payload || payload.data || {}), phase: 'playing' }));
                    setFightersWinner(null);
                    setActiveComponentId(19);
                    break;
                case "fighters.telemetry":
                case "fighters_telemetry":
                    if (payload.payload || payload.data) {
                        setFightersMatchState(prev => ({ ...prev, ...(payload.payload || payload.data), phase: 'playing' }));
                        setActiveComponentId(19);
                    }
                    break;
                case "fighters.paused":
                case "fighters_paused":
                case "fighters_match_paused":
                    setFightersMatchState(prev => ({ ...prev, phase: 'paused' }));
                    break;
                case "fighters.resumed":
                case "fighters_resumed":
                case "fighters_match_resumed":
                    setFightersMatchState(prev => ({ ...prev, phase: 'playing' }));
                    break;
                case "fighters.game_over":
                case "fighters_game_over":
                case "fighters.finished":
                case "fighters_finished":
                    await RemoveExtraClassesOfColorsDynamic();
                    setFightersMatchState(prev => ({ ...prev, ...(payload.payload || payload.data || {}), phase: 'finished' }));
                    setFightersWinner(payload.payload?.winner ?? payload.data?.winner ?? payload.winner);
                    setActiveComponentId(19);
                    break;
                case "fighters.reset":
                case "fighters_reset":
                case "fighters_game_reset":
                    await RemoveExtraClassesOfColorsDynamic();
                    setFightersMatchState({ phase: 'idle' });
                    setFightersWinner(null);
                    setActiveComponentId(19);
                    break;

                // ==========================================
                // REACCIÓN RÁPIDA 1 VS 1 (HU-05)
                // ==========================================
                case "quick_reaction_cover_shown":
                case "quick_reaction_cover":
                case "quickreaction.cover":
                case "quick_reaction_game_scene_shown":
                case "quick_reaction_game_shown":
                case "quick_reaction_game_ready":
                case "quickreaction.game":
                case "quick_reaction.created":
                case "quickreaction.created":
                    await RemoveExtraClassesOfColorsDynamic();
                    const qrThemeData = payload.payload?.theme || payload.data?.theme || payload.payload || payload.data || {};
                    setQuickReactionConfig(qrThemeData);
                    setQuickReactionMatchState({ roomId: payload.payload?.roomId || payload.data?.roomId, phase: payload.payload?.phase || payload.data?.phase || 'cover' });
                    setQuickReactionWinner(null);
                    setActiveComponentId(43);
                    break;
                case "quick_reaction_countdown_tick":
                case "quick_reaction_countdown":
                case "quickreaction.countdown":
                    await RemoveExtraClassesOfColorsDynamic();
                    setQuickReactionMatchState(prev => ({ ...prev, phase: 'countdown', secondsRemaining: payload.payload?.count ?? payload.payload?.secondsRemaining ?? payload.data?.count }));
                    setActiveComponentId(43);
                    break;
                case "quick_reaction_random_wait":
                case "quickreaction.random_wait":
                    await RemoveExtraClassesOfColorsDynamic();
                    setQuickReactionMatchState(prev => ({ ...prev, phase: 'random_wait', ...(payload.payload || payload.data || {}) }));
                    setActiveComponentId(43);
                    break;
                case "quick_reaction_trigger_active":
                case "quickreaction.trigger_active":
                    await RemoveExtraClassesOfColorsDynamic();
                    setQuickReactionMatchState(prev => ({ ...prev, phase: 'trigger_active', triggerTimestampServerMs: payload.payload?.triggerTimestampServerMs ?? payload.data?.triggerTimestampServerMs }));
                    setActiveComponentId(43);
                    break;
                case "quick_reaction_early_fault":
                case "quickreaction.early_fault":
                    await RemoveExtraClassesOfColorsDynamic();
                    setQuickReactionMatchState(prev => ({ ...prev, phase: 'finished', isEarlyFault: true, ...(payload.payload || payload.data || {}) }));
                    setActiveComponentId(43);
                    break;
                case "quick_reaction_match_finished":
                case "quickreaction.finished":
                case "quickreaction.game_over":
                    await RemoveExtraClassesOfColorsDynamic();
                    setQuickReactionMatchState(prev => ({ ...prev, ...(payload.payload || payload.data || {}), phase: 'finished' }));
                    setQuickReactionWinner(payload.payload?.winner ?? payload.data?.winner ?? payload.winner);
                    setActiveComponentId(43);
                    break;
                case "quick_reaction_reset":
                case "quickreaction.reset":
                    await RemoveExtraClassesOfColorsDynamic();
                    setQuickReactionMatchState({ phase: 'game_ready' });
                    setQuickReactionWinner(null);
                    setActiveComponentId(43);
                    break;

                // ==========================================
                // Memorama opera de forma desacoplada en /memory
                // ESTIRA Y AFLOJA / TUG OF WAR (HU-05)
                // ==========================================
                case "tugofwar.cover":
                case "tugofwar_cover":
                case "tugofwar_cover_shown":
                case "tugofwar.game_scene":
                case "tugofwar_game_scene":
                case "tugofwar_game_scene_shown":
                case "tugofwar.game_ready":
                case "tugofwar_game_ready":
                case "tugofwar.created":
                case "tugofwar_created":
                    await RemoveExtraClassesOfColorsDynamic();
                    const tugThemeData = payload.payload?.theme || payload.data?.theme || payload.payload || payload.data || {};
                    setTugOfWarConfig(tugThemeData);
                    setTugOfWarMatchState({ roomId: payload.payload?.roomId || payload.data?.roomId, phase: payload.payload?.phase || payload.data?.phase || 'cover' });
                    setTugOfWarWinner(null);
                    setActiveComponentId(47);
                    break;
                case "tugofwar.countdown":
                case "tugofwar_countdown":
                case "tugofwar_countdown_tick":
                case "tugofwar_countdown_started":
                    await RemoveExtraClassesOfColorsDynamic();
                    setTugOfWarMatchState(prev => ({ ...prev, phase: 'countdown', secondsRemaining: payload.payload?.countdown ?? payload.payload?.secondsRemaining ?? payload.payload?.count ?? payload.data?.countdown ?? payload.data?.count }));
                    setActiveComponentId(47);
                    break;
                case "tugofwar.started":
                case "tugofwar_started":
                case "tugofwar_match_started":
                case "tugofwar_round_started":
                    await RemoveExtraClassesOfColorsDynamic();
                    setTugOfWarMatchState(prev => ({ ...prev, ...(payload.payload || payload.data || {}), phase: 'playing' }));
                    setTugOfWarWinner(null);
                    setActiveComponentId(47);
                    break;
                case "tugofwar.telemetry":
                case "tugofwar_telemetry":
                    if (payload.payload || payload.data) {
                        setTugOfWarMatchState(prev => ({ ...prev, ...(payload.payload || payload.data), phase: 'playing' }));
                        setActiveComponentId(47);
                    }
                    break;
                case "tugofwar.sudden_death":
                case "tugofwar_sudden_death":
                case "tugofwar_sudden_death_started":
                    setTugOfWarMatchState(prev => ({ ...prev, isSuddenDeath: true, phase: 'playing' }));
                    setActiveComponentId(47);
                    break;
                case "tugofwar.paused":
                case "tugofwar_paused":
                case "tugofwar_match_paused":
                    setTugOfWarMatchState(prev => ({ ...prev, phase: 'paused' }));
                    setActiveComponentId(47);
                    break;
                case "tugofwar.resumed":
                case "tugofwar_resumed":
                case "tugofwar_match_resumed":
                    setTugOfWarMatchState(prev => ({ ...prev, phase: 'playing' }));
                    setActiveComponentId(47);
                    break;
                case "tugofwar.game_over":
                case "tugofwar_game_over":
                case "tugofwar.finished":
                case "tugofwar_finished":
                case "tugofwar_match_finished":
                    await RemoveExtraClassesOfColorsDynamic();
                    setTugOfWarMatchState(prev => ({ ...prev, ...(payload.payload || payload.data || {}), phase: 'finished' }));
                    setTugOfWarWinner(payload.payload?.winner ?? payload.data?.winner ?? payload.winner);
                    setActiveComponentId(47);
                    break;
                case "tugofwar.reset":
                case "tugofwar_reset":
                case "tugofwar_match_reset":
                    await RemoveExtraClassesOfColorsDynamic();
                    setTugOfWarMatchState({ phase: 'idle' });
                    setTugOfWarWinner(null);
                    setActiveComponentId(47);
                    break;

                // ==========================================
                // OTRAS DINÁMICAS (Se mantienen intactas)
                // ==========================================
                case "ballons":
                    await RemoveExtraClassesOfColorsDynamic()
                    setBalloonConfig(null); setBalloonWinners(null);
                    setActiveComponentId(9)
                    break
                case "ballonsgame":
                    await RemoveExtraClassesOfColorsDynamic()
                    setActiveComponentId(9.1)
                    break;
                case "balloon.prepare": {
                    await RemoveExtraClassesOfColorsDynamic()
                    const d = payload.data || {}
                    setBalloonConfig({ matchId: d.matchId, startAt: d.startAt, endsAt: d.endsAt, targetTapsPerBalloon: d.targetTapsPerBalloon });
                    setBalloonWinners(null)
                    setActiveComponentId(9.1)
                    break;
                }
                case "balloon.show-winners": {
                    const d = payload.data || {}
                    setBalloonWinners({ winnerType: d.winnerType || "none", winners: d.winners || [], results: d.results || [] })
                    setActiveComponentId(9.1)
                    break
                }
                case "balloon.reset":
                    await RemoveExtraClassesOfColorsDynamic()
                    setBalloonConfig(null); setBalloonWinners(null);
                    setActiveComponentId(9)
                    break;
                case "riddle":
                    await RemoveExtraClassesOfColorsDynamic(); setActiveComponentId(10); break
                case "newquestionriddler":
                    await RemoveExtraClassesOfColorsDynamic()
                    sessionStorage.removeItem('eudnrlanrbaewq')
                    if (payload?.data) { setRiddle(payload.data); setActiveComponentId(10.1); }
                    break
                case "riddlevotingclosed":
                    if (payload?.data) {
                        setRiddle(prev => ({
                            ...(prev || {}),
                            ...payload.data,
                            isVotingOpen: false
                        }));
                        setActiveComponentId(10.1);
                    }
                    break
                case "resumequestionriddler":
                case "riddledisplayitem":
                    await RemoveExtraClassesOfColorsDynamic()
                    if (payload?.data) {
                        setRiddle(prev => ({
                            ...(prev || {}),
                            ...payload.data,
                            isItemVisible: true
                        }));
                        setActiveComponentId(10.1);
                    }
                    break
                case "quizzwithimageandoptions":
                    await RemoveExtraClassesOfColorsDynamic(); setActiveComponentId(10); break
                case "newquestionquizzwithimageandoptions":
                    await RemoveExtraClassesOfColorsDynamic()
                    sessionStorage.removeItem('eudnrlanrbaewq')
                    if (payload?.data) { setRiddle(payload.data); setActiveComponentId(11.1); }
                    break
                case "resumequestionquizzwithimageandoptions":
                    await RemoveExtraClassesOfColorsDynamic()
                    if (payload?.data) { setRiddle(payload.data); setActiveComponentId(11.1); }
                    break
                case "frontpagenoisemeter":
                    await RemoveExtraClassesOfColorsDynamic(); setNoisemeterConfig(null); setNoisemeterWinners(null); setActiveComponentId(12); break
                case 'noisemeter.prepare':
                    await RemoveExtraClassesOfColorsDynamic(); setNoisemeterConfig(payload.data); setNoisemeterWinners(null); setActiveComponentId(12.1); break;
                case 'noisemeter.finished':
                    setNoisemeterWinners(payload.data); setActiveComponentId(12.1); break;
                case "frontpageluchofest":
                    await RemoveExtraClassesOfColorsDynamic(); setLuchoFestConfig(null); setActiveComponentId(13); break
                case "luchofest.start":
                    await RemoveExtraClassesOfColorsDynamic(); setLuchoFestConfig(payload.data); setActiveComponentId(13.1); break
                case "luchofest.stop":
                    await RemoveExtraClassesOfColorsDynamic(); setLuchoFestConfig(null); setActiveComponentId(13); break
                case "luchofest.emergency_promo":
                    setLuchoFestEmergencyTrigger(prev => prev + 1); break
                case "lightshow.prepare":
                    await RemoveExtraClassesOfColorsDynamic(); setLightShowConfig({ ...payload.data, isRunning: false }); setActiveComponentId(14); break
                case "lightshow.start":
                    await RemoveExtraClassesOfColorsDynamic();
                    setLightShowConfig(prevConfig => ({ ...prevConfig, ...payload.data, isRunning: true }));
                    setActiveComponentId(14);
                    break
                case "lightshow.stop":
                    setLightShowConfig(prevConfig => ({ ...prevConfig, isRunning: false })); break
                case "lightshow.late_join":
                    await RemoveExtraClassesOfColorsDynamic();
                    setLightShowConfig({ ...payload.data.config, isRunning: payload.data.isRunning, serverStartTimestampMilliseconds: payload.data.serverStartTimestampMilliseconds })
                    setActiveComponentId(14); break
                case "lightshow.live_config_update":
                    setLightShowConfig(prevConfig => prevConfig ? { ...prevConfig, ...payload.data } : null);
                    break;
                case "zone_mode_changed":
                    if (payload && !payload.isAuto) {
                        try { localStorage.removeItem('user_zone'); } catch (e) {}
                        window.location.reload();
                    }
                    break;
                case "force_relogin":
                    try { localStorage.removeItem('user_zone'); } catch (e) {}
                    window.location.reload();
                    break;
                // case 'voting.start':
                //     setLottery(null); setQuestion(message.data); setResults(null);
                //     setActiveComponentId(16); // ID 16 para tu Voting
                //     break;
                // case 'voting.start':
                //     setVotingConfig(payload.data);
                //     setActiveComponentId(16);
                //     break;
                case 'voting.start':
                    setLottery(null); 
                    setVotingConfig(payload.data); // O setQuestion(payload.data) si le pusiste así al estado
                    //setResults(null);
                    setActiveComponentId(16);
                    break;
                // ==========================================
                // DINÁMICA: GORRAS / BOLITA (CAPS)
                // ==========================================
                case 'caps.layout':
                case 'caps.progress':
                    await RemoveExtraClassesOfColorsDynamic();
                    setActiveComponentId(17);
                    break;

                // ==========================================
                // DINÁMICA: CARRERA CONTINUA (HU-05)
                // ==========================================
                case 'carreracontinua.cover':
                case 'carreracontinua.game':
                case 'carreracontinua.created':
                case 'carreracontinua.countdown':
                case 'carreracontinua.started':
                case 'carreracontinua.progress':
                case 'carreracontinua.paused':
                case 'carreracontinua.resumed':
                case 'carreracontinua.finished':
                case 'carreracontinua.reset':
                    await RemoveExtraClassesOfColorsDynamic();
                    setCarreraContinuaMatchState(payload.payload || payload.data || payload);
                    setCarreraContinuaConfig(payload.theme || payload.data || payload);
                    if (payload.winnerZone || payload.payload?.winnerZone || payload.data?.winnerZone) {
                        setCarreraContinuaWinnerZone(payload.winnerZone || payload.payload?.winnerZone || payload.data?.winnerZone);
                    }
                    setActiveComponentId(18);
                    break;
                default:
                    await RemoveExtraClassesOfColorsDynamic(); setActiveComponentId(null); break
            }
        }

        SetSocketMessageHandler(handler)

        return () => {
            ClearSocketMessageHandler()
        }
    }, [])

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const roomId = queryParams.get('roomId');

        const checkLightShowActive = async () => {
            try {
                const url = roomId 
                    ? `${process.env.REACT_APP_API_URL}LightShow/current-state?roomId=${roomId}`
                    : `${process.env.REACT_APP_API_URL}LightShow/current-state`;
                const response = await fetch(url);
                if (response.ok) {
                    const data = await response.json();
                    if (data && data.isRunning && data.config) {
                        console.log("[Sections.js] Sincronización tardía de LightShow detectada en montaje.");
                        await RemoveExtraClassesOfColorsDynamic();
                        setLightShowConfig({
                            ...data.config,
                            isRunning: true,
                            serverStartTimestampMilliseconds: data.serverStartTimestampMilliseconds
                        });
                        setActiveComponentId(14);
                    }
                }
            } catch (err) {
                console.warn("[Sections.js] Error al consultar current-state en montaje:", err);
            }
        };

        checkLightShowActive();
    }, []);

    useEffect(() => {
        if (!defaultView) return;
        const norm = defaultView.toLowerCase();
        if (norm === 'wait') {
            setActiveComponentId(2);
        } else if (norm === 'welcome' || norm === 'start') {
            setActiveComponentId(1);
        } else if (norm === 'thanks') {
            setActiveComponentId(8);
        }
    }, [defaultView]);


    return (
        isLoading ? (
            <p>Cargando...</p>
        ) : (
            <>
                <div className="Sections">
                    <div className="Sections__Tiles">
                        <p className='text-center'>Zona: {selectedZone ? selectedZone : displayZoneName}</p>

                        {/* BOTÓN DE EMERGENCIA OFFLINE */}
                        {!navigator.onLine && (!activeComponentId || activeComponentId === 1 || activeComponentId === 2 || activeComponentId === 10 || activeComponentId === 13) && (
                            <div className="alert alert-warning text-center mx-auto my-4 shadow-sm" style={{ maxWidth: '400px', borderRadius: '15px' }}>
                                <h5 className="fw-bold mb-2">Modo Offline Activo 📡</h5>
                                <p className="small text-muted mb-3">No detectamos conexión a internet. Puedes ejecutar el show de luces de respaldo localmente.</p>
                                <button 
                                    className="Btn__Adsl--Red w-100 py-2" 
                                    style={{ margin: '0 auto', maxWidth: '280px' }}
                                    onClick={() => {
                                        setLightShowConfig({
                                            isRunning: true,
                                            beatsPerMinute: 120,
                                            flashActive: true,
                                            screenActive: true,
                                            frames: [
                                                { color: '#ff0000', flashOn: true },
                                                { color: '#ffffff', flashOn: false }
                                            ]
                                        });
                                        setActiveComponentId(14);
                                    }}
                                >
                                    Iniciar Show Local
                                </button>
                            </div>
                        )}

                        {activeComponentId === 1 && <Welcome />}
                        {activeComponentId === 2 && <Wait />}
                        {activeComponentId === 3 && <Wait />}
                        {activeComponentId === 3.1 && <Quiz questionId={quizQuestionId} options={quizOptions} />}
                        {activeComponentId === 4 && <InstructionsColors />}
                        {activeComponentId === 4.1 && <Colors color={color} />}
                        {activeComponentId === 5 && <Wait />}
                        {activeComponentId === 5.1 && <Lottery lottery={lottery} />}
                        {activeComponentId === 6 && <Wait />}
                        {activeComponentId === 7 && <Welcome />}
                        {activeComponentId === 8 && <Thanks />}
                        {activeComponentId === 9 && <Wait />}
                        {activeComponentId === 9.1 && (<Balloons config={balloonConfig} winners={balloonWinners} zone={selectedZoneToComponent} />)}
                        {activeComponentId === 10 && <Wait />}
                        {activeComponentId === 10.1 && <Riddle riddle={riddle} currentZone={selectedZoneToComponent} roomId={new URLSearchParams(window.location.search).get('roomId')} />}
                        {activeComponentId === 11.1 && <QuizzWithImageAndOptions quizz={riddle} />}
                        {activeComponentId === 12 && <FrontPageNoisemeterV2 isActiveWomensMode={noisemeterConfig?.isActiveWomensMode} />}
                        {activeComponentId === 12.1 && (<NoisemeterV2 config={noisemeterConfig} winners={noisemeterWinners} userZone={selectedZoneToComponent} />)}
                        {activeComponentId === 13 && <Wait />}
                        {activeComponentId === 13.1 && (<LuchoFest isPracticeRoundParameter={luchoFestConfig?.isPracticeRound} winningZoneParameter={luchoFestConfig?.winningZone} gameSequence={luchoFestConfig?.gameSequence} userZoneParameter={selectedZoneToComponent} emergencyTrigger={luchoFestEmergencyTrigger} />)}
                        {activeComponentId === 14 && (<LightShow config={lightShowConfig} onExit={onLogout} />)}
                        {/* AQUI RENDERIZAMOS EL TIRO A GOL V2 PASANDO selectedZone PARA EVITAR DUPLICADOS */}
                        {activeComponentId === 15 && (<GoalV2 matchState={goalV2MatchState} config={goalV2Config} theme={goalV2Config} winnerZone={goalV2WinnerZone} userZone={selectedZoneToComponent} />)}
                        {activeComponentId === 15.1 && (<GoalV2 matchState={goalV2MatchState} config={goalV2Config} theme={goalV2Config} winnerZone={goalV2WinnerZone} userZone={selectedZoneToComponent} />)}
                        {activeComponentId === 16 && (<Voting config={votingConfig} userZone={selectedZoneToComponent} />)}
                        {activeComponentId === 17 && (<Caps />)}
                        {activeComponentId === 18 && (<CarreraContinuaFan matchState={carreraContinuaMatchState} config={carreraContinuaConfig} winnerZone={carreraContinuaWinnerZone} userZone={selectedZoneToComponent} />)}
                        {activeComponentId === 19 && (<FightersFan matchState={fightersMatchState} config={fightersConfig} winner={fightersWinner} roomId={new URLSearchParams(window.location.search).get('roomId')} />)}
                        {activeComponentId === 42 && (<FightersFan matchState={fightersMatchState} config={fightersConfig} winner={fightersWinner} roomId={new URLSearchParams(window.location.search).get('roomId')} />)}
                        {activeComponentId === 43 && (<QuickReactionFan matchState={quickReactionMatchState} config={quickReactionConfig} winner={quickReactionWinner} roomId={new URLSearchParams(window.location.search).get('roomId')} />)}
                        {/* Memorama opera exclusivamente en /memory */}
                        {activeComponentId === 47 && (<TugOfWarFan matchState={tugOfWarMatchState} config={tugOfWarConfig} winner={tugOfWarWinner} roomId={new URLSearchParams(window.location.search).get('roomId')} />)}
                        {!activeComponentId && <Welcome />}
                    </div>
                </div>
            </>
        )
    )
}

export { Sections };